'use client';

import { Breadcrumb as BreadcrumbComponent } from '@components/breadcrumb';

import { paths } from '@helpers/path';

export function Breadcrumb() {
    return (
        <BreadcrumbComponent
            elements={[
                {
                    name: 'home',
                    label: 'Accueil',
                    href: '/',
                },
                {
                    name: 'home BiG',
                    label: 'Offres box + forfaits',
                    href: paths.promos,
                },
            ]}
        />
    );
}
